import { QueryKey, useQuery } from "react-query";
import { getPermit } from "../../../../queries/permits";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

export default function usePermit({ permitId }: { permitId: number | string }) {
  const networkHeaders = useNetworkHeaders();

  const key = getPermitQueryKey(permitId);
  const permitQuery = useQuery(key, getPermit(networkHeaders), { enabled: !!permitId });
  return permitQuery;
}

export function getPermitQueryKey(permitId: number | string | undefined): QueryKey {
  return ["permits", permitId?.toString()].filter((key) => key);
}
